import { createSlice } from "@reduxjs/toolkit";
import {
  getPharmacyOrders,
  getPharmacyRecentOrders,
  getPharmacyOrdersHistory,
  getPharmacyCartOrderRequests,
} from "../../reducer/pharmacyOrders/pharmacyOrdersReducer";

const initialState = {
  loading: false,
  orders: [],
  pagination: null,
  error: null,
  recentOrders: [],
  recentOrdersLoading: false,
  recentOrdersError: null,
  ordersHistory: [],
  ordersHistoryLoading: false,
  ordersHistoryError: null,
  ordersHistoryPagination: null,
  cartOrderRequests: [],
  cartOrderRequestsLoading: false,
  cartOrderRequestsError: null,
  cartOrderRequestsPagination: null,
};

const pharmacyOrdersSlice = createSlice({
  name: "pharmacyOrders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET ORDERS
      .addCase(getPharmacyOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.orders = [];
        state.pagination = null;
      })
      .addCase(getPharmacyOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload?.data?.orders || [];
        state.pagination = action.payload?.data?.pagination || null;
      })
      .addCase(getPharmacyOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // GET RECENT ORDERS
      .addCase(getPharmacyRecentOrders.pending, (state) => {
        state.recentOrdersLoading = true;
        state.recentOrdersError = null;
      })
      .addCase(getPharmacyRecentOrders.fulfilled, (state, action) => {
        state.recentOrdersLoading = false;
        state.recentOrders = action.payload?.data?.orders || [];
      })
      .addCase(getPharmacyRecentOrders.rejected, (state, action) => {
        state.recentOrdersLoading = false;
        state.recentOrdersError = action.payload;
      })
      // GET ORDERS HISTORY
      .addCase(getPharmacyOrdersHistory.pending, (state) => {
        state.ordersHistoryLoading = true;
        state.ordersHistoryError = null;
        state.ordersHistory = [];
        state.ordersHistoryPagination = null;
      })
      .addCase(getPharmacyOrdersHistory.fulfilled, (state, action) => {
        state.ordersHistoryLoading = false;
        state.ordersHistory = action.payload?.data?.orders || [];
        state.ordersHistoryPagination =
          action.payload?.data?.pagination || null;
      })
      .addCase(getPharmacyOrdersHistory.rejected, (state, action) => {
        state.ordersHistoryLoading = false;
        state.ordersHistoryError = action.payload;
      })
      // GET CART ORDER REQUESTS
      .addCase(getPharmacyCartOrderRequests.pending, (state) => {
        state.cartOrderRequestsLoading = true;
        state.cartOrderRequestsError = null;
        state.cartOrderRequests = [];
        state.cartOrderRequestsPagination = null;
      })
      .addCase(getPharmacyCartOrderRequests.fulfilled, (state, action) => {
        state.cartOrderRequestsLoading = false;
        state.cartOrderRequests = action.payload?.data?.orders || [];
        state.cartOrderRequestsPagination =
          action.payload?.data?.pagination || null;
      })
      .addCase(getPharmacyCartOrderRequests.rejected, (state, action) => {
        state.cartOrderRequestsLoading = false;
        state.cartOrderRequestsError = action.payload;
      });
  },
});

export default pharmacyOrdersSlice.reducer;
